import React from "react";
import "./App.css";
import Question from "./Question.jsx"

function App() {
  return (
    <div className="app">
      <Question />
    </div>
  );
}

export default App;
